import React, { useState, useEffect, useContext } from "react";
// 21-09
import {  Edit32WHITE,
  Approved32,
  PDF32,
  Excel32,
  JPG32,
  PNG32,
  UpdateWhite32,} from "../../../../../public/LoginImages/importimages";
import CreateWorkOrder from "../../WorkOrderManagement/CreateWorkOrder/CreateWorkOrder.js"; 
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";


// 08-10 status color
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 
// 19-10 file type icon
const getFileIcon = (fileName) => {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  if (ext === "pdf") return PDF32;
  if (ext === "xls" || ext === "xlsx") return Excel32;
  if (ext === "jpg" || ext === "jpeg") return JPG32;
  if (ext === "png") return PNG32;
  return UpdateWhite32; // default icon
};
const WorkOrderList = () => {
  const context = useContext(AdminContext);
  const { GetAllWorkOrderList, Usermenu ,WorkManagementApproval } = context;
  const [workorder, setWorkOrderList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
// 21-09
  const [openEdit, setOpenEdit] = useState(false);
const [editData, setEditData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
 const [statusFilter, setStatusFilter] = useState("All");
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  const [menuData, setMenuData] = useState({});

  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };

    getMenu();
  }, []);

  // const getWorkOrderList = async () => {
  //   let data = await GetAllWorkOrderList();
  //   console.log("data", data);

  //   setWorkOrderList(data);
  //   setFilteredBills(data);
  // };
  const getWorkOrderList = async () => {
    let data = await GetAllWorkOrderList();
    console.log("data", data);

    setWorkOrderList(data);
    setFilteredBills(data);
  };

  useEffect(() => {
    getWorkOrderList();
  }, []);
  let workorderList = [];
  if (workorder.length > 0) {
    workorderList = workorder;
  }
  // useEffect(() => {
  //   const lowerSearchTerm = searchTerm.toLowerCase();
  //   const filtered = workorder.filter((bill) =>
  //     Object.values(bill).some((val) =>
  //       (val || "").toString().toLowerCase().includes(lowerSearchTerm),
  //     ),
  //   );
  //   setFilteredBills(filtered);
  //   setCurrentPage(1); // Reset to page 1 on search
  // }, [searchTerm, workorder]);
 
 
 // above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = workorder.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, workorder]);
  const isMaker =
    menuData?.Department_Name === "New Agency Maker" &&
    menuData?.Role === "New Agency Maker";
  console.log("menuData", menuData);

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // First pages
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, 5);
      pages.push("...");
      pages.push(totalPages);

      return pages;
    }

    // Last pages
    if (currentPage >= totalPages - 2) {
      pages.push("...");

      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Middle pages
    pages.push("...");

    pages.push(
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
    );

    pages.push("...");
    pages.push(totalPages);

    return pages;
  };


  // 21-09
  const handleEditWorkOrder = (workorder) => {
  setEditData(workorder);
  setOpenEdit(true);
};

const handleApproveWorkOrder = async (workorder) => {
  const shouldProceed = window.confirm("Are you sure you want to approve this Work Order?");
  if (!shouldProceed) return;

  try {
    const response = await WorkManagementApproval([workorder.WorkOrderID], "Approved", "");
    if (response?.message) alert(response.message);
    else if (response?.error) alert(response.error);
    getWorkOrderList(); // refresh list
  } catch (err) {
    console.error("Error approving Work Order:", err);
    alert("An error occurred while approving.");
  }
};

//   return (

//     <> 
//     {!openEdit ? (
//     <div
//       style={{
//         background: "white",
//         width: "100%",
//          height: "90vh",              // fixed height
//         // height: "auto",
//     display: "flex",             // new
//     flexDirection: "column", 
//         overflow: "hidden",
//         padding: "10px 15px 15px 15px",

//         boxSizing: "border-box",
//         fontFamily: "Inter, sans-serif",
//       }}
//     >
//       {/* //29/10 */}
//      <div
//       style={{
//         width: "100%",
//         background: "#EEF1F6",
//         borderRadius: "12px",
//         padding: "18px 15px",
//         boxSizing: "border-box",
//         boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
//         border: "1px solid #E1E6EF",
//       }}
//     >
//       {/* ---- Header Section ---- */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "10px",
//           padding: "0 20px",
//           width: "100%",
//           boxSizing: "border-box",
//           flexShrink:0
//         }}
//       >
//         <h5
//           style={{
//             fontWeight: "bold",
//             color: "black",
//             display: "flex",
//             alignItems: "center",
//           }}
//         >
//           <img
//             src={"/List-32.png"}
//             alt="Project Icon"
//             style={{ marginRight: "10px", width: 28, height: 28 }}
//           />
//           Work Order Outward List
//         </h5>

//         {/* ---- Search Box ---- */}
//          <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             backgroundColor: "#ffffff",
//             border: "1px solid #d0d7e5",
//             borderRadius: "7px",
//             padding: "7px 10px",
//             width: "250px",
//             height: "36px",
//             boxSizing: "border-box",
//           }}
//         >
//           <img
//             src={"/Search-32.png"}
//             alt="Search Icon"
//             style={{ width: 20, height: 20, marginRight: "8px" }}
//           />
//           <input
//             type="text"
//             placeholder="Search Work Order..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               fontSize: "14px",
//             }}
//           />
//         </div>
//         <select
//     value={statusFilter}
//     onChange={(e) => setStatusFilter(e.target.value)}
//     style={{
//         width: "140px",
//         height: "36px",
//         marginLeft: "10px",
//         border: "1px solid #d5dce5",
//         borderRadius: "8px",
//         padding: "0 10px",
//         fontSize: "12px",
//         outline: "none",
//         background: "#fff",
//         cursor: "pointer"
//     }}
// >
//     <option value="All">All Status</option>
//     <option value="Pending">Pending</option>
//     <option value="SendBack">SendBack</option>
//     <option value="Approved">Approved</option>
//     <option value="Rejected">Rejected</option>
// </select></div>
//       </div>
//       <div
//         style={{
//           width: "100%",
//           maxWidth: "100%",

//           // height: "calc(100% - 52px)",

//           margin: "10px auto 0 auto",

//           backgroundColor: "#ffffff",

//           borderRadius: "14px",

//           boxShadow: "0 3px 12px rgba(0, 0, 0, 0.15)",

//           padding: "0 18px 18px 18px",
//           paddingTop: "18px",
//           boxSizing: "border-box",

//           display: "flex",
//           flexDirection: "column",

//           overflow: "hidden",
// //  flex: "1 1 auto",  
//           minWidth: 0,
//           minHeight: 0,
//           // height: "auto",

//           // flexShrink: 0,
//         }}
//       >
//         {/* ---- Table Section ---- */}
//         <div
//           style={{
//             width: "100%",
//             // height: "100%",
//             minWidth: 0,
//             minHeight: 0,
//             overflowX: "auto",
//             overflowY: "auto",
//             border: "1px solid #d9e1f2",
//             borderRadius: "10px",

//             backgroundColor: "#ffffff",

//             boxShadow: "0 2px 8px rgba(0, 0, 0, 0.10)",

//             boxSizing: "border-box",

//             flex: "1 1 auto",

//             WebkitOverflowScrolling: "touch",

//             scrollbarWidth: "thin",
//           }}
//         >
//           <table
//             // style={{
//             //   backgroundColor: "#ffffff",
//             //   width: "max-content",
//             //   minWidth: "1700px",
//             //   borderCollapse: "collapse",
//             //   fontSize: "11px",

//             //   tableLayout: "auto",
//             //   // whiteSpace: "nowrap",
//             // }}
//            style={{
//     backgroundColor: "#ffffff",
//     width: "100%",
//     minWidth: "1200px",
//     borderCollapse: "separate",   
//     borderSpacing: 0,            
//     fontFamily: "Inter, sans-serif",
//     fontSize: "12px",
//   }}
//           >
//             <thead>
//               <tr
//                 style={{
//                 //28/10
//                   backgroundColor: "#2D79D9",
//                   color: "white",
//                   fontSize: "14px",
//                   fontWeight: "400",
//                   textAlign: "center",
//                   whiteSpace: "nowrap",
//                   height: "36px",
//                 }}
//               >
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Sr.No</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Financial Year</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Project ID</th>
//                 <th style={{ padding: "8px 10px" ,position: "sticky", top: 0, zIndex: 2 }}>Project Name</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Project Cost</th>
//                 <th style={{ padding: "8px 10px" ,position: "sticky", top: 0, zIndex: 2 }}>GRCopy</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Implementing Agency</th>
//                 {/* <th style={{ padding: "10px" }}>CRC</th>
//                             <th style={{ padding: "10px" }}>Budget Head</th> */}
//                 <th style={{ padding: "8px 10px" ,position: "sticky", top: 0, zIndex: 2 }}>Vendor Name</th>
//                 <th style={{ padding: "8px 10px" ,position: "sticky", top: 0, zIndex: 2 }}>Work Name</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2 }}>Work Order No</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Work Order Date</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Work End Date</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Approved Work Amount</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Paid Amount</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Remaining Amount</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Copy of Work Order</th>
//                 <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Creation Date</th>
//                 {isMaker && <th style={{ padding: "10px",position: "sticky", top: 0, zIndex: 2  }}>Remark</th>}
//                 <th style={{padding:"8px 10px",position: "sticky", top: 0, zIndex: 2 }}>Status</th>
//                 {/* 21-09 */}
//                 {isMaker && <th style={{ padding: "8px 10px",position: "sticky", top: 0, zIndex: 2  }}>Action</th>}
// {isMaker && <th style={{ padding: "8px 10px" ,position: "sticky", top: 0, zIndex: 2 }}>Approve</th>}
//               </tr>
//             </thead>

//             {currentBills?.map((workorder, index) => (
//               <tbody key={index}>
//                 <tr
//                   style={{
//                     height: "40px",
//                     fontSize: "13px",
//                     fontWeight: "400",
//                     textAlign: "center",

//                      backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
//                   }}
//                 >
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {indexOfFirstBill + index + 1}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.FinancialYear}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                       color:"#5295c9"
//                     }}
//                   >
//                     {workorder.ProjectID}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.ProjectName}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {/* {workorder.ProjectCost} */}
//                     {Number(workorder.ProjectCost || 0).toLocaleString("en-IN")}
//                   </td>
//                           <td style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", textAlign: "center" }}>
//                    {workorder.GRCopy ? (
//                      <a
//                        href={`${apiurl}/ProjectDocsImages/${workorder.GRCopy}`}
//                        target="_blank"
//                        rel="noreferrer"
//                        title={workorder.GRCopy}
//                        style={{
//                          display: "flex",
//                          alignItems: "center",
//                          justifyContent: "center",
//                          gap: "5px",
//                          width: "100%",
//                          overflow: "hidden",
//                          textDecoration: "none",
//                          color: "#0d6efd",
//                        }}
//                      >
//                        <img
//                          src={getFileIcon(workorder.GRCopy)}
//                          alt="file icon"
//                          style={{ width: "20px", height: "20px", flexShrink: 0 }}
//                        />
//                        {workorder.ProjectID} GR Copy
//                      </a>
//                    ) : (
//                      <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
//                    )}
//                  </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.PIU}
//                   </td>
//                   {/* <td style={{ padding: "10px" }}>{workorder.CRC}</td> */}
//                   {/* <td style={{ padding: "10px" }}>{workorder.BudgetHead}</td> */}
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.ContractorName}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                       width:"150px"
//                     }}
//                   >
//                     {workorder.WorkName}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.WorkOrderNo}
//                   </td>
//                   <td>{workorder.WorkOrderDate?.split("T")[0]}</td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.WorkEndDate?.split("T")[0]}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {/* {workorder.ApprovedWorkAmount} */}₹
//                     {Number(workorder.ApprovedWorkAmount || 0).toLocaleString(
//                       "en-IN",
//                     )}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {/* {workorder.PaidAmount} */}₹
//                     {Number(workorder.PaidAmount || 0).toLocaleString("en-IN")}
//                   </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {/* {workorder.RemainingAmount} */}₹
//                     {Number(workorder.RemainingAmount || 0).toLocaleString(
//                       "en-IN",
//                     )}
//                   </td>
//                                  <td style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", textAlign: "center" }}>
//                          {workorder.CopyofWorkOrder ? (
//                            <a
//                              href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`}
//                              target="_blank"
//                              rel="noreferrer"
//                              title={workorder.CopyofWorkOrder}
//                              style={{
//                                display: "flex",
//                                alignItems: "center",
//                                justifyContent: "center",
//                                gap: "5px",
//                                width: "100%",
//                                overflow: "hidden",
//                                textDecoration: "none",
//                                color: "#0d6efd",
//                              }}
//                            >
//                              <img
//                                src={getFileIcon(workorder.CopyofWorkOrder)}
//                                alt="file icon"
//                                style={{ width: "20px", height: "20px", flexShrink: 0 }}
//                              /> Work Order Copy
//                            </a>
//                          ) : (
//                            <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
//                          )}
//                        </td>
//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       height: "40px",
//                       verticalAlign: "middle",
//                       textAlign: "center",
//                     }}
//                   >
//                     {workorder.Date?.split("T")[0]}
//                   </td>
//                   {isMaker && (
//                     <td
//                       style={{
//                         padding: "8px 10px",
//                         height: "40px",
//                         verticalAlign: "middle",
//                         textAlign: "center",
//                       }}
//                     >
//                       {workorder.Remark || "--"}
//                     </td>
//                   )}

//                   {/* <td style={{padding:"8px 10px",height:"40px",verticalAlign:"middle",textAlign:"center"}}>{workorder.Status || "-"}</td> */}
//                     <td style={{ padding: "10px", textAlign: "center" }}>
//   <StatusBadge status={workorder. Status} />
// </td>
 
//                   {/* 21-09 */}
//                   {isMaker && (
//   <td style={{ padding: "8px 10px", height: "40px", verticalAlign: "middle", textAlign: "center" }}>
//     <button
//       onClick={() => handleEditWorkOrder(workorder)}
//       disabled={workorder.Status !== "SendBack"}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: "5px",
//         margin: "auto",
//         padding: "6px 12px",
//         background:
//           workorder.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
//         color: "#fff",
//         border: "none",
//         borderRadius: "6px",
//         fontSize: "13px",
//         fontWeight: "600",
//         cursor: workorder.Status === "SendBack" ? "pointer" : "not-allowed",
//       }}
//     >
//       <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
//       Edit
//     </button>
//   </td>
// )}

// {isMaker && (
//   <td style={{ padding: "8px 10px", height: "40px", verticalAlign: "middle", textAlign: "center" }}>
//     <button
//       onClick={() => handleApproveWorkOrder(workorder)}
//       disabled={workorder.Status !== "SendBack"}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: "5px",
//         margin: "auto",
//         padding: "6px 12px",
//         background:
//           workorder.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
//         color: "#fff",
//         border: "none",
//         borderRadius: "6px",
//         fontSize: "13px",
//         fontWeight: "600",
//         cursor: workorder.Status === "SendBack" ? "pointer" : "not-allowed",
//       }}
//     >
//       <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
//       Approve
//     </button>
//   </td>
// )}
//                 </tr>
//               </tbody>
//             ))}
//           </table>
//           {/* 

// // 24-09 no data foound msg */}
//               {(!Array.isArray(currentBills) || currentBills.length === 0) && (
//             <div
//               style={{
//                 position: "sticky",
//                 left: 0,
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "150px",
//                 boxSizing: "border-box",
//                 backgroundColor: "#f9f9f9",
//                 color: "black",
//                 fontSize: "15px",
//                 fontWeight: 500,
//               }}
//             >
//               No data available
//             </div>
//           )}

//           {/* -------- */}
//         </div>

//         {/* </div> */}

//         {/* ---- Pagination ---- */}

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginTop: "20px",
//                 flexShrink: 0,  
//             // padding: "0 10px",
//           }}
//         >
//           {/* Showing Entries */}

//           <p
//             style={{
//               margin: 0,
//               fontSize: "13px",
//               color: "black",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
//             {Math.min(indexOfLastBill, filteredBills?.length)} of{" "}
//             {filteredBills?.length} entries
//           </p>

//           {/* Pagination */}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "18px",
//             }}
//           >
//             {/* Previous */}

//             <button
//               type="button"
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//               style={{
//                 border: "none",
//                 background: "transparent",
//                 color: "#2ea4e7",
//                 cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                 fontSize: "13px",
//                 padding: 0,
//                 opacity: currentPage === 1 ? 0.5 : 1,
//               }}
//             >
//               ‹ Previous
//             </button>

//             {/* Page Numbers */}

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "20px",
//               }}
//             >
//               {getPageNumbers().map((page, index) => {
//                 if (page === "...") {
//                   return (
//                     <span
//                       key={`dots-${index}`}
//                       style={{
//                         color: "#444",
//                         fontSize: "13px",
//                       }}
//                     >
//                       ...
//                     </span>
//                   );
//                 }

//                 return (
//                   <button
//                     type="button"
//                     key={page}
//                     onClick={() => setCurrentPage(page)}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: currentPage === page ? "#2ea4e7" : "#444",
//                       cursor: "pointer",
//                       fontSize: "13px",
//                       fontWeight: currentPage === page ? "600" : "400",
//                       textDecoration:
//                         currentPage === page ? "underline" : "none",
//                     }}
//                   >
//                     {page}
//                   </button>
//                 );
//               })}
//             </div>

//             {/* Next */}

//             <button
//               type="button"
//               onClick={() =>
//                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//               }
//               disabled={currentPage === totalPages || totalPages === 0}
//               style={{
//                 border: "none",
//                 background: "transparent",
//                 color: "#2ea4e7",
//                 cursor:
//                   currentPage === totalPages || totalPages === 0
//                     ? "not-allowed"
//                     : "pointer",
//                 fontSize: "13px",
//                 padding: 0,
//                 opacity:
//                   currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
//               }}
//             >
//               Next ›
//             </button>
//           </div>
//         </div>
//       </div>
//     </div></div>
//     ) : (
//       <div
//         style={{
//           width: "100%",
//           padding: "20px",
//           background: "#f5f7fb",
//           minHeight: "100vh",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             marginBottom: "15px",
//           }}
//         >
//           <button
//             onClick={() => {
//               setOpenEdit(false);
//               setEditData(null);
//             }}
//             style={{
//               background: "#0d6efd",
//               color: "#fff",
//               border: "none",
//               padding: "10px 18px",
//               borderRadius: "8px",
//               fontWeight: "600",
//               cursor: "pointer",
//             }}
//           >
//             ← Back
//           </button>
//         </div>

//         <CreateWorkOrder
//           isEdit={true}
//           projectDatainward={editData}
//           onSuccess={() => {
//             setOpenEdit(false);
//             setEditData(null);
//             getWorkOrderList(); // refresh outward table
//           }}
//           onCancel={() => {
//             setOpenEdit(false);
//             setEditData(null);
//           }}
//         />
//       </div>
//     )}
//     </>
//   );
  return (

    <> 
    {!openEdit ? (
    <div
      style={{
        background: "white",
        width: "100%",
         height: "90vh",              // fixed height
    display: "flex",             // new
    flexDirection: "column", 
        overflow: "hidden",
        //29/10
        // padding: "20px 15px 15px 15px",
       padding:"20px",
        boxSizing: "border-box",
        fontFamily: "Inter, sans-serif",
      }}
    >

      {/* <div
      style={{
        width: "100%",
        background: "transparent",
        padding: 0,
        boxSizing: "border-box",
      }}
    > */}

    {/* //29/10 */}
     <div
      style={{
        width: "100%",
        background: "#EEF1F6",
        borderRadius: "12px",
        padding: "18px 15px",
        boxSizing: "border-box",
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
        border: "1px solid #E1E6EF",
      }}
    >
      {/* ---- Header Section ---- */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          padding: "0 20px",
          width: "100%",
          boxSizing: "border-box",
          flexShrink:0
        }}
      >
        <h5
          style={{
            fontWeight: "bold",
            color: "black",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={"/List-32.png"}
            alt="Project Icon"
            style={{ marginRight: "10px", width: 28, height: 28 }}
          />
          Work Order Outward List
        </h5>

        {/* ---- Search Box ---- */}
         <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#ffffff",
            border: "1px solid #d0d7e5",
            borderRadius: "7px",
            padding: "7px 10px",
            width: "250px",
            height: "36px",
            boxSizing: "border-box",
          }}
        >
          <img
            src={"/Search-32.png"}
            alt="Search Icon"
            style={{ width: 20, height: 20, marginRight: "8px" }}
          />
          <input
            type="text"
            placeholder="Search Work Order..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              border: "none",
              outline: "none",
              background: "transparent",
              width: "100%",
              fontSize: "14px",
            }}
          />
        </div>
        <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    style={{
        width: "140px",
        height: "36px",
        marginLeft: "10px",
        border: "1px solid #d5dce5",
        borderRadius: "8px",
        padding: "0 10px",
        fontSize: "12px",
        outline: "none",
        background: "#fff",
        cursor: "pointer"
    }}
>
    <option value="All">All Status</option>
    <option value="Pending">Pending</option>
    <option value="SendBack">SendBack</option>
    <option value="Approved">Approved</option>
    <option value="Rejected">Rejected</option>
</select></div>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: "100%",

          // height: "calc(100% - 52px)",

          margin: "10px auto 0 auto",

          backgroundColor: "#ffffff",

          borderRadius: "14px",

          boxShadow: "0 3px 12px rgba(0, 0, 0, 0.15)",

          padding: "0 18px 18px 18px",
          paddingTop: "18px",
          boxSizing: "border-box",

          display: "flex",
          flexDirection: "column",

          overflow: "hidden",

          //23/10 no data availble height

//  flex: "1 1 auto",  
          minWidth: 0,
          minHeight: 0,
          // height: "auto",

          // flexShrink: 0,
        }}
      >
        {/* ---- Table Section ---- */}
        <div
          style={{
            width: "100%",
            // height: "100%",
            minWidth: 0,
            minHeight: 0,
            overflowX: "auto",
            overflowY: "auto",
            border: "1px solid #d9e1f2",
            borderRadius: "10px",

            backgroundColor: "#ffffff",

            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.10)",

            boxSizing: "border-box",
//28/10
            flex: "0 1 auto",

            WebkitOverflowScrolling: "touch",

            scrollbarWidth: "thin",
          }}
        >
          {/* //28/10 */}
         <table
  style={{
    backgroundColor: "#ffffff",
    width: "100%",
    minWidth: "1200px",
    borderCollapse: "separate",   
    borderSpacing: 0,            
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
  }}
>
            <thead>
              <tr
                style={{
                  //28/10
                  backgroundColor: "#2D79D9",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "400",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  height: "36px",
                }}
              >
                <th style={{ padding: "8px 10px",position: "sticky", top:"0", zIndex: 2  }}>Sr.No</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Financial Year</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0", zIndex: 2  }}>Project ID</th>
                <th style={{ padding: "8px 10px" ,position: "sticky", top:"0", zIndex: 2 }}>Project Name</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0", zIndex: 2  }}>Project Cost</th>
                <th style={{ padding: "8px 10px" ,position: "sticky", top:"0", zIndex: 2 }}>GRCopy</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Implementing Agency</th>
                {/* <th style={{ padding: "10px" }}>CRC</th>
                            <th style={{ padding: "10px" }}>Budget Head</th> */}
                <th style={{ padding: "8px 10px" ,position: "sticky", top:"0",  zIndex: 2 }}>Vendor Name</th>
                <th style={{ padding: "8px 10px" ,position: "sticky", top:"0", zIndex: 2 }}>Work Name</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2 }}>Work Order No</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0", zIndex: 2  }}>Work Order Date</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Work End Date</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Approved Work Amount</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Paid Amount</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0", zIndex: 2  }}>Remaining Amount</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Copy of Work Order</th>
                <th style={{ padding: "8px 10px",position: "sticky", top:"0",  zIndex: 2  }}>Creation Date</th>
                {isMaker && <th style={{ padding: "10px",position: "sticky", top:"0",  zIndex: 2  }}>Remark</th>}
                <th style={{padding:"8px 10px",position: "sticky", top:"0",  zIndex: 2 }}>Status</th>
                {/* 21-09 */}
                {isMaker && <th style={{ padding: "8px 10px",position: "sticky", top:"0", zIndex: 2  }}>Action</th>}
{isMaker && <th style={{ padding: "8px 10px" ,position: "sticky", top:"0",  zIndex: 2 }}>Approve</th>}
              </tr>
            </thead>

            {currentBills?.map((workorder, index) => (
              <tbody key={index}>
                  {/* //28/10 */}
                <tr
                  style={{
                    height: "40px",
                    fontSize: "14px",
                    fontWeight: "400",
                    textAlign: "center",
                   
                    backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                  }}
                >
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {indexOfFirstBill + index + 1}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.FinancialYear}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                      //29/10
                      color:"blue"
                    }}
                  >
                    {workorder.ProjectID}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.ProjectName}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {/* {workorder.ProjectCost} */}
                    {Number(workorder.ProjectCost || 0).toLocaleString("en-IN")}
                  </td>
               <td style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", textAlign: "center" }}>
  {workorder.GRCopy ? (
    <a
      href={`${apiurl}/ProjectDocsImages/${workorder.GRCopy}`}
      target="_blank"
      rel="noreferrer"
      title={workorder.GRCopy}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        width: "100%",
        overflow: "hidden",
        textDecoration: "none",
        color: "#0d6efd",
      }}
    >
      <img
        src={getFileIcon(workorder.GRCopy)}
        alt="file icon"
        style={{ width: "20px", height: "20px", flexShrink: 0 }}
      />
      {workorder.ProjectID} GR Copy
    </a>
  ) : (
    <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
  )}
</td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.PIU}
                  </td>
                  {/* <td style={{ padding: "10px" }}>{workorder.CRC}</td> */}
                  {/* <td style={{ padding: "10px" }}>{workorder.BudgetHead}</td> */}
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.ContractorName}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                      width:"150px"
                    }}
                  >
                    {workorder.WorkName}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.WorkOrderNo}
                  </td>
                  <td>{workorder.WorkOrderDate?.split("T")[0]}</td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.WorkEndDate?.split("T")[0]}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {/* {workorder.ApprovedWorkAmount} */}₹
                    {Number(workorder.ApprovedWorkAmount || 0).toLocaleString(
                      "en-IN",
                    )}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {/* {workorder.PaidAmount} */}₹
                    {Number(workorder.PaidAmount || 0).toLocaleString("en-IN")}
                  </td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {/* {workorder.RemainingAmount} */}₹
                    {Number(workorder.RemainingAmount || 0).toLocaleString(
                      "en-IN",
                    )}
                  </td>
                <td style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", textAlign: "center" }}>
  {workorder.CopyofWorkOrder ? (
    <a
      href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`}
      target="_blank"
      rel="noreferrer"
      title={workorder.CopyofWorkOrder}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        width: "100%",
        overflow: "hidden",
        textDecoration: "none",
        color: "#0d6efd",
      }}
    >
      <img
        src={getFileIcon(workorder.CopyofWorkOrder)}
        alt="file icon"
        style={{ width: "20px", height: "20px", flexShrink: 0 }}
      /> Work Order Copy
    </a>
  ) : (
    <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
  )}
</td>
                  <td
                    style={{
                      padding: "8px 10px",
                      height: "40px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    {workorder.Date?.split("T")[0]}
                  </td>
                  {isMaker && (
                    <td
                      style={{
                        padding: "8px 10px",
                        height: "40px",
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}
                    >
                      {workorder.Remark || "--"}
                    </td>
                  )}

                  {/* <td style={{padding:"8px 10px",height:"40px",verticalAlign:"middle",textAlign:"center"}}>{workorder.Status || "-"}</td> */}
                    <td style={{ padding: "10px", textAlign: "center" }}>
  <StatusBadge status={workorder. Status} />
</td>
 
                  {/* 21-09 */}
                  {isMaker && (
  <td style={{ padding: "8px 10px", height: "40px", verticalAlign: "middle", textAlign: "center" }}>
    <button
      onClick={() => handleEditWorkOrder(workorder)}
      disabled={workorder.Status !== "SendBack"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        margin: "auto",
        padding: "6px 12px",
        background:
          workorder.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: workorder.Status === "SendBack" ? "pointer" : "not-allowed",
      }}
    >
      <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
      Edit
    </button>
  </td>
)}

{isMaker && (
  <td style={{ padding: "8px 10px", height: "40px", verticalAlign: "middle", textAlign: "center" }}>
    <button
      onClick={() => handleApproveWorkOrder(workorder)}
      disabled={workorder.Status !== "SendBack"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        margin: "auto",
        padding: "6px 12px",
        background:
          workorder.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: workorder.Status === "SendBack" ? "pointer" : "not-allowed",
      }}
    >
      <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
      Approve
    </button>
  </td>
)}
                </tr>
              </tbody>
            ))}
          </table>
          {/* 

// 24-09 no data foound msg */}
              {(!Array.isArray(currentBills) || currentBills.length === 0) && (
            <div
              style={{
                position: "sticky",
                left: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "150px",
                boxSizing: "border-box",
                backgroundColor: "#f9f9f9",
                color: "black",
                fontSize: "15px",
                fontWeight: 500,
              }}
            >
              No data available
            </div>
          )}

          {/* -------- */}
        </div>

        {/* </div> */}

        {/* ---- Pagination ---- */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
                flexShrink: 0,  
            // padding: "0 10px",
          }}
        >
          {/* Showing Entries */}

          <p
            style={{
              margin: 0,
              fontSize: "13px",
              color: "black",
              whiteSpace: "nowrap",
            }}
          >
            Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
            {Math.min(indexOfLastBill, filteredBills?.length)} of{" "}
            {filteredBills?.length} entries
          </p>

          {/* Pagination */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "18px",
            }}
          >
            {/* Previous */}

            <button
              type="button"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                fontSize: "13px",
                padding: 0,
                opacity: currentPage === 1 ? 0.5 : 1,
              }}
            >
              ‹ Previous
            </button>

            {/* Page Numbers */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {getPageNumbers().map((page, index) => {
                if (page === "...") {
                  return (
                    <span
                      key={`dots-${index}`}
                      style={{
                        color: "#444",
                        fontSize: "13px",
                      }}
                    >
                      ...
                    </span>
                  );
                }

                return (
                  <button
                    type="button"
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: currentPage === page ? "#2ea4e7" : "#444",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: currentPage === page ? "600" : "400",
                      textDecoration:
                        currentPage === page ? "underline" : "none",
                    }}
                  >
                    {page}
                  </button>
                );
              })}
            </div>

            {/* Next */}

            <button
              type="button"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages || totalPages === 0}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor:
                  currentPage === totalPages || totalPages === 0
                    ? "not-allowed"
                    : "pointer",
                fontSize: "13px",
                padding: 0,
                opacity:
                  currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
              }}
            >
              Next ›
            </button>
          </div>
        </div>
      </div>
   </div> </div>
    ) : (
      <div
        style={{
          width: "100%",
          padding: "20px",
          background: "#f5f7fb",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "15px",
          }}
        >
          <button
            onClick={() => {
              setOpenEdit(false);
              setEditData(null);
            }}
            style={{
              background: "#0d6efd",
              color: "#fff",
              border: "none",
              padding: "10px 18px",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            ← Back
          </button>
        </div>

        <CreateWorkOrder
          isEdit={true}
          projectDatainward={editData}
          onSuccess={() => {
            setOpenEdit(false);
            setEditData(null);
            getWorkOrderList(); // refresh outward table
          }}
          onCancel={() => {
            setOpenEdit(false);
            setEditData(null);
          }}
        />
      </div>
    )}
    </>
  );
};

export default WorkOrderList;
